import React, { useState } from 'react';

import { TableCell, TableRow, Checkbox } from '@mui/material';
import { ILegalRequirementTemplateFullObject } from '../../../../Interfaces/ILegalRequirementTemplate';

interface IProps {
  currentRequirement: ILegalRequirementTemplateFullObject;

  handleChoosenRequirementChange: Function;
  isChecked: boolean;
}

export const LegalRequirementRow: React.FC<IProps> = props => {
  const [currentRequirementEdit, setCurrentRequirementEdit] = useState(
    props.currentRequirement
  );

  const handleCheckRequirement = (checked: boolean) => {
    props.handleChoosenRequirementChange(props.currentRequirement, checked);
  };

  return (
    <>
      <TableRow>
        <TableCell></TableCell>
        <TableCell>
          <Checkbox
            onChange={e => handleCheckRequirement(e.target.checked)}
            checked={props.isChecked}
          ></Checkbox>
        </TableCell>
        <TableCell>
          {props.currentRequirement.LegalRequirementTemplate}
        </TableCell>
        <TableCell></TableCell>
        <TableCell></TableCell>
        <TableCell>
          {props.currentRequirement.isInterneLegalRequirement ? 'Ja' : 'Nein'}
        </TableCell>
        <TableCell>
          {props.currentRequirement.canUploadFilesClient ? 'Ja' : 'Nein'}
        </TableCell>
        <TableCell>
          {props.currentRequirement.canUploadFilesEmployees ? 'Ja' : 'Nein'}
        </TableCell>
        <TableCell>
          {props.currentRequirement.sendMail ? 'Ja' : 'Nein'}
        </TableCell>
        <TableCell></TableCell>
      </TableRow>
    </>
  );
};
